export const articleContent: Record<string, {
  title: string;
  category: string;
  date: string;
  readCount: string;
  author: string;
  image: string;
  content: { type: 'heading' | 'paragraph' | 'image'; text?: string; src?: string }[];
}> = {
  'article-1': {
    title: '《流浪地球3》首周票房突破30亿，国产科幻再创辉煌',
    category: '票房盘点',
    date: '2026-08-01',
    readCount: '128,000',
    author: '影视观察员',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scifi%20blockbuster%20scene%20with%20warm%20golden%20and%20red%20lighting%2C%20dramatic%20space%20theme%20atmosphere%2C%20movie%20premiere%20night%20red%20carpet%20setting%2C%20no%20visible%20faces%2C%20cinematic%20photography%2C%20rich%20warm%20contrast&width=1200&height=600&seq=article-detail-01&orientation=landscape',
    content: [
      { type: 'heading', text: '票房奇迹：首周末狂揽30亿' },
      { type: 'paragraph', text: '国产科幻巨制《流浪地球3》于上周五正式上映，短短三天时间就创造了惊人的30亿人民币票房成绩，不仅刷新了中国电影史首周末票房纪录，更超越了前作《流浪地球2》同期表现，展现出中国科幻电影日益增长的号召力和市场潜力。' },
      { type: 'paragraph', text: '据灯塔专业版数据显示，《流浪地球3》首日票房高达8.5亿，次日攀升至10.2亿，周日更是达到了11.3亿的峰值。如此强劲的票房走势，让业界纷纷将最终票房预测上调至80亿以上，有望成为新的中国影史票房冠军。' },
      { type: 'heading', text: '口碑持续走高：豆瓣评分8.9' },
      { type: 'paragraph', text: '除了票房表现亮眼，《流浪地球3》在口碑方面同样取得了优异成绩。目前该片在豆瓣的评分稳定在8.9分，超过95%的观众给出了四星及以上的好评。观众普遍认为，本片在视觉特效、剧情深度和人物塑造等方面相比前两部有显著提升。' },
      { type: 'paragraph', text: '"这才是科幻电影应该有的样子。"一位资深影评人表示，"《流浪地球3》不仅在视觉上达到了国际一流水准，更重要的是它讲述了一个真正打动人心的中国故事。电影中关于人类命运共同体的思考，具有非常深刻的现实意义。"' },
      { type: 'heading', text: '国产科幻崛起：从追赶到引领' },
      { type: 'paragraph', text: '《流浪地球》系列的成功绝非偶然。从2019年第一部横空出世，到2023年第二部持续发力，再到如今第三部创造历史，这个系列见证了中国科幻电影从无到有、从弱到强的全过程。它向世界证明，中国人也能拍出世界级的科幻大片。' },
      { type: 'paragraph', text: '业内人士分析指出，《流浪地球》系列的成功得益于多方面因素：一是中国电影工业化水平的快速提升，为科幻大片提供了技术保障；二是优秀IP的持续积累和深耕，形成了强大的品牌效应；三是中国观众对本土科幻题材的强烈认同感和情感共鸣。' },
      { type: 'heading', text: '国际反响：海外市场表现出色' },
      { type: 'paragraph', text: '《流浪地球3》不仅在国内市场大放异彩，在海外市场同样表现不俗。影片同步在北美、欧洲、东南亚等多个地区上映，首周末海外票房累计超过1.5亿美元，打破了华语电影海外开画纪录。多家国际媒体对影片给予了高度评价。' },
      { type: 'paragraph', text: '《纽约时报》评论称："《流浪地球3》展示了中国电影工业的惊人进步，其视觉效果和叙事野心足以媲美任何好莱坞顶级科幻大片。"IMDB上该片目前评分为8.2分，来自全球观众的正面评价持续增长。' },
    ],
  },
  'article-2': {
    title: '2026暑期档神仙打架：十大必看影视剧推荐',
    category: '观影指南',
    date: '2026-07-28',
    readCount: '96,500',
    author: '片多多编辑部',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20summer%20movie%20season%20vibe%20with%20warm%20golden%20sunset%20light%2C%20vintage%20movie%20theater%20atmosphere%2C%20film%20reels%20and%20posters%2C%20nostalgic%20cinema%20aesthetic%2C%20no%20visible%20faces%2C%20rich%20warm%20tones&width=1200&height=600&seq=article-detail-02&orientation=landscape',
    content: [
      { type: 'heading', text: '暑期档竞争白热化：多部大片扎堆上映' },
      { type: 'paragraph', text: '2026年的暑期档堪称近年来竞争最为激烈的一季。从科幻巨制到温情家庭片，从热血动作到浪漫爱情，各种类型的影视作品轮番登场，为观众带来了一场视觉与情感的饕餮盛宴。面对琳琅满目的选择，片多多编辑部为你精心挑选了十部最值得观看的作品。' },
      { type: 'heading', text: '科幻类：《流浪地球3》一骑绝尘' },
      { type: 'paragraph', text: '毫无疑问，《流浪地球3》是今年暑期档最受期待的影片。作为中国科幻电影的标杆之作，该片在视觉特效、剧情设计和情感表达上都达到了新的高度。如果你是科幻迷，这部作品绝对不容错过。目前该片票房已突破30亿，口碑持续走高。' },
      { type: 'heading', text: '奇幻类：《封神第二部》震撼来袭' },
      { type: 'paragraph', text: '《封神第二部》延续了第一部的超高水准，商周大战的宏大场面令人叹为观止。导演精心构建的中国神话宇宙逐渐成形，姜子牙、哪吒、杨戬等经典人物形象深入人心。影片在IMAX影厅的观影体验更是让人沉浸其中。' },
      { type: 'heading', text: '古装类：《长安十二时辰》剧场版全新演绎' },
      { type: 'paragraph', text: '改编自热门IP的《长安十二时辰》剧场版为观众呈现了一个鲜活的盛唐长安。精致的服化道、考究的历史细节、紧凑的悬念设计，让这部古装悬疑大片成为暑期档的一匹黑马。对于那些喜欢烧脑剧情的观众来说，这绝对是一部不容错过的佳作。' },
      { type: 'heading', text: '更多精彩推荐' },
      { type: 'paragraph', text: '除了上述大片外，《深海寻踪》的悬疑氛围、《狂飙人生》的热血动作、《星辰大海》的浪漫爱情、《猎冰》的紧张刺激以及《少年歌行》的国漫之美，都值得你在炎炎夏日中静下心来细细品味。每部作品都有其独特的魅力和看点，总有一款适合你。' },
    ],
  },
  'article-3': {
    title: '国产动漫崛起：《少年歌行》口碑爆棚背后的故事',
    category: '深度解析',
    date: '2026-07-25',
    readCount: '85,200',
    author: '动漫观察家',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20animation%20production%20scene%20with%20warm%20artistic%20lighting%2C%20Chinese%20ink%20brush%20animation%20style%20elements%2C%20creative%20studio%20environment%2C%20warm%20vibrant%20colors%2C%20no%20visible%20faces%2C%20artistic%20composition&width=1200&height=600&seq=article-detail-03&orientation=landscape',
    content: [
      { type: 'heading', text: '从默默无闻到口碑爆棚' },
      { type: 'paragraph', text: '《少年歌行》自上映以来，凭借精美的画面、扎实的剧情和对中国传统文化的巧妙融合，迅速赢得了观众的广泛好评。豆瓣评分高达9.3分，被誉为"国产动漫的新标杆"。那么，这部作品成功背后的故事究竟是怎样的呢？' },
      { type: 'paragraph', text: '制作团队花费了整整四年的时间来打磨这部作品。导演在接受采访时表示："我们不想走捷径。每一个场景、每一个动作、每一个表情，都经过了反复的推敲和打磨。我们希望通过这部作品，向世界展示中国动画的实力和独特美学。"' },
      { type: 'heading', text: '中国风美学：传统文化的现代表达' },
      { type: 'paragraph', text: '《少年歌行》的一大亮点是其独特的中国风美学。创作团队深入研究了中国传统水墨画、工笔画和壁画艺术，将这些传统元素与现代动画技术完美融合。影片中的山水场景宛如一幅幅流动的水墨画，人物动作则融入了中国传统武术的神韵。' },
      { type: 'paragraph', text: '美术指导透露："我们参考了大量的唐代壁画和宋代山水画，力求在每一帧画面中都能体现出中国传统艺术的精髓。同时，我们也大胆采用了现代色彩理论和光影技术，让传统美学在银幕上焕发出全新的生命力。"' },
      { type: 'heading', text: '技术突破：国产动画工业的里程碑' },
      { type: 'paragraph', text: '在技术层面，《少年歌行》同样取得了重大突破。制作团队自主研发了多套动画制作工具和渲染算法，大幅提升了画面质量和工作效率。特别是在毛发渲染、流体模拟和布料解算等关键技术领域，都达到或超过了国际一流水平。' },
    ],
  },
  'article-4': {
    title: '从《封神》系列看中国神话IP影视化的未来',
    category: '行业观察',
    date: '2026-07-20',
    readCount: '72,800',
    author: '影视评论人',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20Chinese%20mythology%20film%20scene%20with%20warm%20golden%20and%20crimson%20tones%2C%20ancient%20Chinese%20palace%20silhouette%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20no%20visible%20faces%2C%20cinematic%20composition&width=1200&height=600&seq=article-detail-04&orientation=landscape',
    content: [
      { type: 'heading', text: '神话IP：一座有待挖掘的文化金矿' },
      { type: 'paragraph', text: '中国拥有世界上最丰富的神话传说资源，从《山海经》到《封神演义》，从《西游记》到《聊斋志异》，这些经典IP蕴含着取之不尽的创作灵感。《封神》系列电影的成功，为这些沉睡的文化宝藏找到了一条通往现代银幕的道路。' },
      { type: 'paragraph', text: '《封神》系列电影的成功并非偶然。制作团队在尊重原著精神的基础上，大胆进行了现代化的改编和创新。他们将中国传统神话中的神仙妖怪、法术神器和宏大战争，以世界级的视觉特效呈现在观众面前，让人耳目一新。' },
      { type: 'heading', text: '宇宙构建：漫威模式的中国化探索' },
      { type: 'paragraph', text: '《封神》系列的成功引发了业内对于构建"中国神话宇宙"的热烈讨论。与漫威宇宙类似，中国神话体系中存在着大量相互关联的人物和故事，这为构建一个宏大的影视宇宙提供了天然的基础。' },
      { type: 'paragraph', text: '业内人士分析指出，构建中国神话宇宙需要在以下几个方面下功夫：第一，建立统一的世界观和叙事体系；第二，精心设计人物成长弧线和相互关系；第三，在每部独立作品中保持高质量的制作水准；第四，建立跨媒体的IP运营体系，包括影视、游戏、衍生品等多个领域。' },
      { type: 'heading', text: '未来展望：从追赶到引领' },
      { type: 'paragraph', text: '随着中国电影工业的持续发展和技术水平的不断提升，我们有理由相信，未来将会有更多优秀的中国神话IP影视作品涌现出来。这些作品不仅将丰富国内观众的精神文化生活，更将成为中国文化走向世界的重要载体。' },
    ],
  },
};